module.exports = __webpack_public_path__ + "static/media/11.55965617.JPG";